
export default {
    head() {
        return {
            title: this.narratorcomp.metatitle ? this.narratorcomp.metatitle : this.narratorcomp.title,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.narratorcomp.metadesc,
                }
            ],
        }
    },

    data() {
        return {
            narratorcomp: null,
            url_copied: false,
            genres: null,
            genders: null,
            ages: null,
            languages: null,
            page: 1,
            total_pages: null,
            active_genre: 0,
            filter_genders: [],
            filter_ages: [],
            filter_language: 0,
            filter_native: false,
            filter_topic: 0,
        };
    },

    asyncData(context) {
        return context.$axios
            .get('/narratorcomps/' + context.params.narratorcomp)
            .then((res) => {
                return {
                    narratorcomp: res.data.narratorcomp,
                    total_pages: res.data.total_pages,
                    genres: res.data.genres,
                    genders: res.data.genders,
                    ages: res.data.ages,
                    languages: res.data.languages,
                }
            })
            .catch((e) => {
                context.error({ statusCode: 404 })
            })
    },

    // watch: {
    //     filter_genders: function (val, oldVal) {
    //         this.page = 1
    //         this.getNarratorcompNarrators()
    //     },
    //     filter_ages: function (val, oldVal) {
    //         this.page = 1
    //         this.getNarratorcompNarrators()
    //     },
    //     filter_native: function (val, oldVal) {
    //         this.page = 1
    //         this.getNarratorcompNarrators()
    //     },
    //     filter_language: function (val, oldVal) {
    //         this.page = 1
    //         this.getNarratorcompNarrators()
    //     },
    // },

    methods: {
        narrators_count(choice) {
            const diktorov = {
                'ru': ['дикторов', 'диктор', 'диктора', 'дикторов'],
                'en': ['narrators', 'narrator', 'narrators'],
            }

            const locale = this.$i18n.locale

            const pluralizationRules = {
                /**
                 * @param choice {number} индекс выбора, переданный в $tc: `$tc('path.to.rule', choiceIndex)`
                 * @param choicesLength {number} общее количество доступных вариантов
                 * @returns финальный индекс для выбора соответственного варианта слова
                 */
                'ru': function (choice, choicesLength) {
                    // this === VueI18n экземпляра, так что свойство locale также существует здесь

                    if (choice === 0) {
                        return 0;
                    }

                    const teen = choice > 10 && choice < 20;
                    const endsWithOne = choice % 10 === 1;

                    if (choicesLength < 4) {
                        return (!teen && endsWithOne) ? 1 : 2;
                    }
                    if (!teen && endsWithOne) {
                        return 1;
                    }
                    if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
                        return 2;
                    }

                    return (choicesLength < 4) ? 2 : 3;
                },
                'en': function (choice, choicesLength) {
                    if (choice === 0) {
                        return 0;
                    }
                    if (choice === 1) {
                        return 1;
                    }
                    return 2
                },
            }
            const variant = pluralizationRules[locale](choice, diktorov[locale].length)
            return diktorov[locale][variant]
        },

        onUpdateFilter(data) {
            this.page = 1
            this.active_genre = data.filter_genre
            this.filter_genders = data.filter_genders
            this.filter_ages = data.filter_ages
            this.filter_language = data.filter_language
            this.active_genre = data.filter_genre
            this.filter_featured = data.filter_featured
            this.filter_topic = data.filter_topic
            this.getNarratorcompNarrators()
        },

        getNarratorcompNarrators() {
            this.$axios
                .get('/narratorcomps/' + this.$route.params.narratorcomp, {
                    params: {
                        page: this.page,
                        genre: this.active_genre,
                        gender: this.filter_genders,
                        age: this.filter_ages,
                        topic: this.filter_topic,
                        language: this.filter_language,
                        native: + this.filter_native,
                    }
                })
                .then((res) => {
                    if (this.page > 1) {
                        this.narratorcomp.narrators = this.narratorcomp.narrators.concat(res.data.narratorcomp.narrators)
                    }
                    else this.narratorcomp.narrators = res.data.narratorcomp.narrators

                    this.total_pages = res.data.total_pages
                    // console.log(this.page+' '+this.total_pages)
                })


        },

        // resetFilters() {
        //     this.filter_ages = []
        //     this.filter_genders = []
        //     this.filter_native = false
        //     this.filter_language = 0
        // },

        copyLink() {
            let copyUrlBtn = document.querySelector('.copyToClipBoardBtn');

            let tempInput = document.createElement('textarea');

            tempInput.style.fontSize = '12pt';
            tempInput.style.border = '0';
            tempInput.style.padding = '0';
            tempInput.style.margin = '0';
            tempInput.style.position = 'absolute';
            tempInput.style.left = '-9999px';
            tempInput.setAttribute('readonly', '');

            tempInput.value = window.location.href;

            copyUrlBtn.parentNode.appendChild(tempInput);

            tempInput.select();
            tempInput.setSelectionRange(0, 99999);

            document.execCommand('copy');

            tempInput.parentNode.removeChild(tempInput);

            this.url_copied = true
        },
    },

    mounted() {

    },

}
